export default {
    // Header Section
    "discover_your": "మీ",
    "sadesati": "సాడే సాతి",
    "saturn_influence_analysis": "శని ప్రభావ విశ్లేషణ",
    "sadesati_description": "మీ జీవితంపై శని ప్రభావాన్ని సమగ్రంగా విశ్లేషించండి. సవాళ్లను అభివృద్ధి మరియు విజయానికి అవకాశాలుగా మార్చే అంతర్దృష్టులు మరియు పరిహారాలను తెలుసుకోండి.",

    "sadesati_your": "సాడే సాతి విశ్లేషణ",

    // Service Information
    "enter_details_for_sadesati": "సాడే సాతి విశ్లేషణ కోసం మీ వివరాలు నమోదు చేయండి",
    "complete_sadesati_analysis": "పూర్తి సాడే సాతి విశ్లేషణ",
    "service_price": "సేవా మూల్యం",
    "comprehensive_sadesati_analysis_note": "శని గ్రహ సంచార ప్రభావాల లోతైన విశ్లేషణ మరియు వ్యక్తిగత పరిహార మార్గదర్శకత్వం",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరు నమోదు చేయండి",
    "name_saturn_influence": "మీ పేరు కంపనలు శని శక్తి నమూనాలతో పరస్పర చర్య చేస్తాయి",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామా నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబర్ నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_moon_position": "మీ చంద్ర రాశి మరియు సాడే సాతి దశను నిర్ణయించడానికి అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_critical_for_sadesati": "ఖచ్చితమైన చంద్ర రాశి లెక్కింపు కోసం ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_essential_for_sadesati": "స్థాన కోర్డినేట్లు గ్రహ లెక్కలను ప్రభావితం చేస్తాయి",
    "preferred_language": "ఇష్టపడే భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ సాడే సాతి విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core SadeSati Features
    "sadesati_phase_identification": "సాడే సాతి దశ గుర్తింపు",
    "saturn_effects_analysis": "శని ప్రభావాల విశ్లేషణ",
    "remedies_and_solutions": "పరిహారాలు & పరిష్కారాలు",
    "timeline_predictions": "కాలక్రమ భవిష్యవాణులు",
    "life_guidance_during_sadesati": "సాడే సాతి కాలంలో జీవిత మార్గదర్శకత్వం",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ సాడే సాతి విశ్లేషణలో ఉన్నవి",
    "complete_sadesati_timeline": "పూర్తి సాడే సాతి కాలక్రమం",
    "saturn_influence_analysis": "శని ప్రభావ విశ్లేషణ",
    "personalized_remedies": "వ్యక్తిగత పరిహారాలు",
    "life_guidance_insights": "జీవిత మార్గదర్శకత్వం & అంతర్దృష్టులు",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా సాడే సాతి విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపు ప్రాసెస్ చేస్తున్నాము",
    "processing_request": "విశ్లేషణ తయారు చేస్తున్నాము",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "sadesati_analysis_processing": "మీ సాడే సాతి విశ్లేషణ మా నిపుణ వేద జ్యోతిష్కులచే తయారు చేయబడుతోంది. మీరు మీ జీవితంపై శని యొక్క ప్రస్తుత ప్రభావం గురించి వివరమైన అంతర్దృష్టులను పొందుతారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "పేమెంట్ ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_12_hours_delivery_note": "మీ వివరమైన సాడే సాతి నివేదిక 12 గంటలలోపు సిద్ధంగా ఉంటుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్లు పొందండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ డెలివర్ చేయబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ సాడే సాతి విశ్లేషణ ప్యాకేజీ",
    "detailed_sadesati_report": "సమగ్ర సాడే సాతి నివేదిక (PDF)",
    "saturn_phase_analysis": "శని దశ & కాలక్రమ విశ్లేషణ",
    "remedial_measures_guidance": "పరిహార చర్యలు & మార్గదర్శకత్వం",
    "life_predictions_timeline": "జీవిత భవిష్యవాణులు & కాలక్రమం",
    "spiritual_guidance_saturn": "శని కాలం కోసం ఆధ్యాత్మిక మార్గదర్శకత్వం",

    // Visual Content
    "sample_sadesati_analysis": "నమూనా సాడే సాతి విశ్లేషణ",
    "sadesati_phase": "సాడే సాతి దశ",
    "sample_sadesati_description": "ప్రస్తుతం శిఖర దశలో - గరిష్ట శని ప్రభావ కాలం",
    "sample_sadesati_preview": "దశ వివరాలతో మీ వ్యక్తిగత సాడే సాతి విశ్లేషణ ప్రివ్యూ",
    "sadesati_phases": "సాడే సాతి దశలు",

    // SadeSati Phase Types
    "rising_phase": "ఉదయ దశ",
    "peak_phase": "శిఖర దశ",
    "setting_phase": "అస్తమయ దశ",

    // Status & Processing
    "your_sadesati_analysis_status": "మీ సాడే సాతి విశ్లేషణ స్థితి",
    "processing_your_analysis": "శని ప్రభావాన్ని విశ్లేషిస్తున్నాము",
    "analysis_processing_message": "మా వేద జ్యోతిష్య నిపుణులు శని యొక్క ప్రస్తుత స్థానం మరియు మీ జీవిత మార్గంపై దాని ప్రభావాలను అధ్యయనం చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో",
    "pending": "వేచి ఉన్న",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్లు ప్రారంభించబడ్డాయి",
    "delivery_within_12_hours": "నివేదిక 12 గంటలలో సిద్ధం",

    // Support & Contact
    "contact_support": "జ్యోతిష్య మద్దతు సంప్రదించండి",
    "need_help": "మార్గదర్శకత్వం అవసరమా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అన్ని అవసరమైన జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // SadeSati-Specific Elements
    "saturn_transit": "శని గ్రహ సంచారం",
    "moon_sign": "చంద్ర రాశి",
    "saturn_position": "శని యొక్క ప్రస్తుత స్థానం",
    "sadesati_duration": "సాడే సాతి వ్యవధి",
    "phase_timeline": "దశ కాలక్రమం",
    "saturn_effects": "శని ప్రభావాలు",

    // Phase Analysis
    "first_phase": "మొదటి దశ (2.5 సంవత్సరాలు)",
    "second_phase": "రెండవ దశ (2.5 సంవత్సరాలు)",
    "third_phase": "మూడవ దశ (2.5 సంవత్సరాలు)",
    "phase_characteristics": "దశ లక్షణాలు",
    "phase_challenges": "దశ సవాళ్లు",
    "phase_opportunities": "దశ అవకాశాలు",

    // Effects & Influences
    "career_effects": "కెరీర్ & వృత్తిపరమైన ప్రభావాలు",
    "health_effects": "ఆరోగ్యం & సంక్షేమ ప్రభావాలు",
    "relationship_effects": "సంబంధాల ప్రభావాలు",
    "financial_effects": "ఆర్థిక ప్రభావం",
    "mental_effects": "మానసిక & భావోద్వేగ ప్రభావాలు",
    "spiritual_effects": "ఆధ్యాత్మిక అభివృద్ధి ప్రభావాలు",

    // Remedies & Solutions
    "saturn_remedies": "శని పరిహారాలు",
    "gemstone_recommendations": "రత్న సిఫార్సులు",
    "mantra_chanting": "మంత్ర జపం",
    "fasting_recommendations": "ఉపవాస మార్గదర్శకాలు",
    "charity_suggestions": "దాన కార్యక్రమాలు",
    "worship_rituals": "పూజా కర్మలు",
    "lifestyle_changes": "జీవనశైలి మార్పులు",

    // Timeline & Predictions
    "current_phase": "ప్రస్తుత దశ",
    "remaining_duration": "మిగిలిన వ్యవధి",
    "next_phase_start": "తదుపరి దశ ప్రారంభ తేదీ",
    "sadesati_end_date": "సాడే సాతి ముగింపు తేదీ",
    "monthly_predictions": "నెలవారీ భవిష్యవాణులు",
    "yearly_overview": "వార్షిక అవలోకనం",

    // Detailed Analysis Sections
    "saturn_mythology": "వేద పురాణాలలో శని",
    "karmic_lessons": "కార్మిక పాఠాలు",
    "past_life_karma": "పూర్వ జన్మ కర్మ",
    "spiritual_significance": "ఆధ్యాత్మిక ప్రాధాన్యత",
    "growth_opportunities": "అభివృద్ధి అవకాశాలు",
    "life_lessons": "శని నుండి జీవిత పాఠాలు",

    // Practical Guidance
    "do_and_dont": "సాడే సాతి సమయంలో చేయవలసినవి & చేయకూడనివి",
    "precautions": "తీసుకోవలసిన జాగ్రత్తలు",
    "best_practices": "ఉత్తమ అభ్యాసాలు",
    "meditation_practices": "ధ్యాన అభ్యాసాలు",
    "yoga_recommendations": "యోగ సిఫార్సులు",
    "dietary_guidelines": "ఆహార మార్గదర్శకాలు",

    // Support & Guidance
    "coping_strategies": "దూకుడు వ్యూహాలు",
    "stress_management": "ఒత్తిడి నిర్వహణ",
    "emotional_support": "భావోద్వేగ మద్దతు పద్ధతులు",
    "family_guidance": "కుటుంబ సంబంధాల మార్గదర్శకత్వం",
    "professional_guidance": "వృత్తిపరమైన జీవిత మార్గదర్శకత్వం",

    // Advanced Analysis
    "saturn_aspects": "శని దృష్టులు",
    "planetary_combinations": "గ్రహ కలయికలు",
    "dasha_analysis": "దశా కాల విశ్లేషణ",
    "transit_effects": "గ్రహ సంచార ప్రభావాలు",
    "yogas_formed": "శనితో ఏర్పడిన యోగాలు"
};
